module.exports = __webpack_public_path__ + "images/bg.png?bbfdf3370790a0e9c56d6ed2a1a2e034";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.png
// module id = 288
// module chunks = 0